import InitiatePasswordReset from './InitiatePasswordReset';

export default InitiatePasswordReset;